<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Настройки системы

  .container.mt-5
    .white_block
      .row
        .col-sm-6.shopSettings
          .inputModule
            input-module(
              type="select",
              title="Приветственная группа",
              v-model="shopSettings.default_group",
              :values="groups",
              valueKey="client_group_id",
              valueName="client_group_name",
              about="В какую группу попадает новый гость при регистрации?"
            )
          //- .inputModule
          //-     input-module(type="checkbox" title="Пуш «‎Спасибо за визит»" v-model="shopSettings.thanks_pushes" label="Включить" about="Когда чек закроется, гостю придёт пуш с благодарностью за визит.")
          .inputModule
            input-module(
              type="checkbox",
              title="Геопуши на iOS",
              v-model="shopSettings.geopushIOS",
              label="Включить"
            )
          .inputModule
            input-module(
              type="checkbox",
              title="Геопуши на Android",
              v-model="shopSettings.geopushAndroid",
              label="Включить"
            )
          .inputModule.extended
            input-module(
              type="checkbox",
              title="Пуш в День Рождения гостя",
              v-model="shopSettings.hb_pushes",
              label="Включить",
              about="Пуш будет отправлен после 12:00 дня."
            )
            input-module(
              type="text",
              title="Текст пуша в День Рождения гостя",
              v-model="shopSettings.hb_pushes_text",
              :disabled="(shopSettings.hb_pushes == 0).toString()",
              :placements="[ { value: 'GUESTNAME', name: 'Имя гостя' }, { value: 'GUESTLASTNAME', name: 'Фамилия гостя' }, { value: 'GUESTFULLNAME', name: 'Полное имя гостя' }, ]",
              emojis="true"
            )
          .inputModule.extended
            input-module(
              type="checkbox",
              title="Пуш за несколько дней до Дня Рождения гостя",
              v-model="shopSettings.pre_hb_pushes",
              label="Включить",
              about="Пуш будет отправлен после 18:00 вечера."
            )
            input-module(
              type="number",
              title="За сколько дней до ДР отправлять пуш",
              v-model="shopSettings.pre_hb_pushes_until",
              :disabled="(shopSettings.pre_hb_pushes == 0).toString()"
            )
            input-module(
              type="text",
              title="Текст пуша",
              v-model="shopSettings.pre_hb_pushes_text",
              :disabled="(shopSettings.pre_hb_pushes == 0).toString()",
              :placements="[ { value: 'GUESTNAME', name: 'Имя гостя' }, { value: 'GUESTLASTNAME', name: 'Фамилия гостя' }, { value: 'GUESTFULLNAME', name: 'Полное имя гостя' }, ]",
              emojis="true"
            )
          button.styled(
            v-on:click="saveSettingns()",
            :disabled="groups.length == 0"
          ) Сохранить
</template>
<script>
import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from "../../apiDriver";

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  data() {
    return {
      shopSettings: {
        default_group: "",
        thanks_pushes: 0,
        geopushIOS: 0,
        geopushAndroid: 0,
      },
      groups: [],
    };
  },

  computed: {},

  mounted() {
    this.loadShopSettings();
    this.loadUserGroups();
  },

  methods: {
    async loadUserGroups() {
      let x = (
        await apiDriver.services.api.get("cards", "settings/getAllPosGroups")
      ).data;
      // console.log(x.groups)
      this.groups = x.groups;
    },
    async loadShopSettings() {
      let x = (await apiDriver.services.api.get("cards", "settings/shopConfig"))
        .data;
      // console.log('loadShopSettings:',x.settings);
      this.shopSettings = x.settings;
    },
    async saveSettingns() {
      this.$toast.success("Настройки успешно сохранены!");
      let x = (
        await apiDriver.services.api.post(
          "cards",
          "settings/shopConfig",
          this.shopSettings
        )
      ).data;
      // console.log("saveSttings:", x);
      // this.se = x.groups;
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.design {
  background: white;
}

.inputModule {
  margin-bottom: 10px;

  &.extended {
    border-left: 4px solid #f4f3ef;
    padding-left: 15px;
    margin-left: 10px;
    padding-top: 10px;
  }
}

@media (prefers-color-scheme: dark) {
  .inputModule {
    &.extended {
      border-left: 4px solid #202020;
    }
  }
}
</style>
